import { Box } from '@zillow/constellation-10';

export const ContentWidthControl = ({ children }: { children: React.ReactNode }) => (
    <Box
        css={{
            maxWidth: {
                lg: '60%',
            },
        }}>
        {children}
    </Box>
);
